module.exports = __webpack_public_path__ + "static/media/default_org_avatar.8e19b6ee.svg";